<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      section: 'Head'
    }
  },
  beforeCreate: function () {
    if (!this.$session.exists()) {
      //logout();
      this.$router.push('/login')
    }
  },
  mounted() {
    if (this.$session.exists()) {
      //console.log('Hay sesión')
      // Recuperar datos del almacenamiento local después de iniciar la aplicación para persistencia de datos.
      const storedData = localStorage.getItem('userData');
      if (storedData) {
        const { dni, nombres } = JSON.parse(storedData);
        this.$store.commit('SET_DNI', dni);
        this.$store.commit('SET_NOMBRES', nombres);
      }
      // Recuperar userRol del almacenamiento local para persistencia de datos.
      const storedUserRol = localStorage.getItem('userRolData');
      if (storedUserRol) {
        const userRol = JSON.parse(storedUserRol);
        this.$store.commit('SET_USER_ROL', userRol);
      }

      // Recuperar userMail del almacenamiento local para persistencia de datos.
      /*
      const storedUserMail = localStorage.getItem('userMailData');
      if (storedUserMail) {
        const userMail = JSON.parse(storedUserMail);
        this.$store.commit('enviarCorreo', userMail);
      }
      */
    } else {
      //console.log('No hay sesión')
    }
  },  

  methods: {
    logout() {
      //Limpiar los datos de la sesión
      this.$store.commit('SET_USER', null)
      //this.$store.commit('SET_TOKEN', null)
      // Verificar si hay un token antes de llamar a SET_TOKEN
      if (this.$store.state.token) {
        this.$store.commit('SET_TOKEN', { token: null, expiresIn: null })
        //localStorage.removeItem('AccessToken');
        //localStorage.removeItem('tokenExpiration');
      }
      // Limpiar los datos del dni, nombre y userRol
      this.$store.commit('CLEAR_USER_DATA');
      /*
      if (window.localStorage) {
        //window.localStorage.setItem('user', null)
        //window.localStorage.setItem('token', null)
        window.localStorage.removeItem('AccessToken');
        window.localStorage.removeItem('tokenExpiration');        
        window.localStorage.removeItem('TokenCurrentTime');        
        window.localStorage.removeItem('TokenExpirationTime');
      }
      */
      this.$session.destroy()
      localStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?d99b2d9c